import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import PhoneImage from "../../assets/images/telas.svg";

// Texto
const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #ffffff;
  text-align: left;
`;

// Container dos steps
const ContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 520px;
  border-left: 2px solid white;
  width: 100%;

  @media (max-width: 768px) {
    height: 480px;
    margin-bottom: 100px;
  }

  @media (max-width: 576px) {
    height: 440px;
  }
`;

// Step individual
const StepWrapper = styled.div<{ position: number }>`
  display: flex;
  align-items: center;
  z-index: 1;
  position: relative;
  left: -19px;

  ${({ position }) => {
    if (position === 0) {
      return `top: -22px;`;
    } else if (position === 2) {
      return `bottom: -22px;`;
    }
    return "";
  }}

  @media (max-width: 768px) {
    ${({ position }) => {
    if (position === 0) {
      return `top: -54px;`;
    } else if (position === 2) {
      return `bottom: -54px;`;
    }
    return "";
  }}
  }
`;

const StepCircleWrapper = styled.div`
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const CircleDiv = styled.div`
  width: 22px;
  height: 22px;
  background-color: #ffffff;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CircleIntoDiv = styled.div`
  width: 12px;
  height: 12px;
  background-color: #4162fd;
  border-radius: 12px;
`;

const BodyTexts = styled.div`
  color: #ffffff;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleItem = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 30px;
  }
`;

const SubtitleItem = styled.span`
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 30px;
  }
`;

const ImagePhone = styled.img`
  width: 100%;
  max-width: 400px;
  margin: 40px auto;

  @media (max-width: 576px) {
    width: 90%;
    max-width: 450px;
  }

  @media (max-width: 992px) {
    width: 100%;
    max-width: 500px;
    margin-top: 0;
  }
`;

const Steps = () => {
  return (
    <Container
      style={{ textAlign: "center", backgroundColor: "#4162FD" }}
      id="section-2"
    >
      <br />
      <br />
      <Title>3 passos simples para começar</Title>
      <br />
      <Row
        xs="1fr"
        sm="1fr"
        md="1fr"
        lg="55% auto"
        xl="55% auto"
        style={{ marginTop: "60px", paddingRight: "40px", paddingLeft: "40px" }}
      >
        <StepsComponent />
        <ImagePhone src={PhoneImage} />
      </Row>
      <br />
      <br />
    </Container>
  );
};

const StepsComponent = () => {
  const steps = [
    {
      title: "Crie sua conta",
      subtitle:
        "Cadastre-se gratuitamente e tenha acesso a todas as funcionalidades.",
    },
    {
      title: "Adicione seus imóveis",
      subtitle: "Configure os detalhes do imóvel e do contrato.",
    },
    {
      title: "Gerencie seus aluguéis",
      subtitle:
        "Assine contratos, automatize cobranças e monitore tudo no app.",
    },
  ];

  return (
    <ContainerDiv>
      {steps.map((step, index) => (
        <StepWrapper key={index} position={index}>
          <StepCircleWrapper>
            <CircleDiv>{index === 1 && <CircleIntoDiv />}</CircleDiv>
          </StepCircleWrapper>
          <BodyTexts>
            <TitleItem>{step.title}</TitleItem>
            <SubtitleItem>{step.subtitle}</SubtitleItem>
          </BodyTexts>
        </StepWrapper>
      ))}
    </ContainerDiv>
  );
};

export default Steps;
